export var BASE_URL = '';

if (window.location.host.includes("localhost") || window.location.host.includes("127.0.0.1")) {
  BASE_URL = 'http://localhost:8080';
} else {
  BASE_URL = window.location.origin + '/slickbots-ws';
}

export const API_URL = BASE_URL + '/api';
export const WS_URL = BASE_URL.replace('https://', 'wss://').replace('http://', 'ws://');
